import React from 'react';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';

import Row from '@/src/components/Layouts/Row/Row';

//import Uploader from '@/src/components/Antd/Uploader/UploaderComponent';
import Image from 'src/pages/ProductEditor/Components/Image/Image1';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Images = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { fileList, onChange, setFileList, disabled } = props;
  return (
    <SectionWrapper
      title={getI18n('allProducts.addproductset.component_image_general_title')}
      subtitle={getI18n(
        'allProducts.addproductset.component_image_general_subtitle',
      )}>
      <Row
        elements={[
          {
            child: (
              <Image
                disabled={disabled}
                onChange={onChange}
                fileList={fileList}
                setFileList={setFileList}
              />
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};
export default Images;
